module.exports = 'react-ansi-style-';
